import { min } from 'lodash';

import { useCurrentTime } from '@/hooks/useCurrentTime';
import { HouseholdLoadingStep } from '@/modules/household/components/HouseholdLoadingSteps/HouseholdLoadingSteps';
import { KgLoadingStatus } from '@/types/schema';

import { HouseholdLoading_StateFragment } from '../graphql/KGLoading.generated';

/** Estimated copy pacing, not backend milestones. Session time survives reloads. */
export function useHouseholdLoadingStep({
  snapshot,
  preparingQuestions,
}: {
  snapshot: HouseholdLoading_StateFragment;
  preparingQuestions?: boolean;
}): HouseholdLoadingStep {
  const now = useCurrentTime(1000).getTime();
  // Concurrent uploads share the oldest active session's clock. Retained
  // completed sessions must not make a new upload start on the final step.
  const startedAt = min(
    snapshot.sessions
      .filter((session) => session.status === KgLoadingStatus.Processing)
      .map((session) => session.startedAt.getTime())
  );
  const elapsed = startedAt === undefined ? 0 : Math.max(0, now - startedAt);

  if (preparingQuestions) return 'details';
  if (elapsed < 10_000) return 'documents';
  if (elapsed < 35_000) return 'members';
  if (elapsed < 80_000) return 'connections';
  if (elapsed < 125_000) return 'ownership';
  return 'details';
}
